import React from 'react'

interface NumericRendererProps {
  value?: number
  onClick?: () => void
}

const NumericRenderer: React.FC<NumericRendererProps> & { RENDERER_TYPE: string } = props => {
  const { value, onClick } = props

  const handleClick = (_e: React.MouseEvent<HTMLSpanElement>) => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <span className="content-renderer content-renderer--numeric numeric-renderer" onClick={handleClick}>
      {value}
    </span>
  )
}

NumericRenderer.RENDERER_TYPE = 'numeric'

export default NumericRenderer
